import { toggleMenu } from "../../../common/custom";

const Header = () => {
  return (
    <div className="top-header">
      <div className="custom-container">
        <div>
          <img src="./images/toplogo.png" alt="" />
        </div>
        <div className="support-button">
          <a
            href="mailto:appointment@healthassure.in"
            className="btn btn-primary mail-header-button"
          >
            <img
              src="./images/emailicon.png"
              style={{ width: "16px" }}
              className="me-1"
              alt=""
            />
            {window.innerWidth <= 567 ? "" : "appointment@healthassure.in"}
          </a>
          <a
            href="tel:022-61676600"
            className="btn btn-primary mail-header-button"
          >
            <img
              src="./images/bxs_phone-call.png"
              style={{ width: "16px" }}
              className="me-1"
              alt=""
            />
            {window.innerWidth <= 567 ? "" : "022-61676600"}
          </a>
        </div>
      </div>
      <div className="toggle-menu">
        <i className="fa-solid fa-bars" onClick={toggleMenu}></i>
      </div>
      <div className="show-notification" style={{ display: "none" }}>
        <i className="fa-solid fa-bell"></i>
        <span className="notification-count">10</span>
      </div>
    </div>
  );
};

export default Header;
